module.exports = __webpack_public_path__ + "img/行业应用_商业办公.c2696d4f.svg";